import { FC, useState, useEffect } from 'react';
import Link from 'next/link';
import { parseISO, format } from 'date-fns';
import { getLanguage, getPodcastNoun } from '@/helpers/helpers';
import { getAuthorFullName } from '@/helpers/helpers';
import BookInfoImg from '../book-info-img/BookInfoImg';
import BookMidBtn from '@/components/ui/book-mid-btn/BookMidBtn';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { IPodcastsDetailData, IPodcastsDetailAuthor, IPodcastsDetailGenre } from '@/interfaces/podcastsDetail.interface';
import { IPodcastDetail } from '@/interfaces/podcastDetail.interface';
import { IBookPageForms } from '@/interfaces/bookPageForms';
import styles from './../book-info/BookInfo.module.scss';

interface IAllPodcasts extends IPodcastDetail, IPodcastsDetailData {}

interface IBookInfoPodcast {
  book: IAllPodcasts;
  formRef: React.RefObject<HTMLDivElement>;
  isPodcast?: boolean;
  isPodcastsFree?: boolean;
  setIsFormsActive?: (isFormActive: IBookPageForms) => void;
}

const BookInfoPodcast: FC<IBookInfoPodcast> = ({ book, formRef, isPodcast, setIsFormsActive, isPodcastsFree }) => {
  const { title, genres, lang } = book;
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  });

  return (
    <>
      <div className={styles.bookInfo}>
        <BookInfoImg book={book} formRef={formRef} setIsFormsActive={setIsFormsActive} isPodcast={isPodcast} />
        <div className={styles.bookInfo__desc}>
          <div className={styles.bookInfo__descWrap}>
            <h1 className={styles.bookInfo__tile} data-widget-litres-book="1">
              {isPodcast ? book.podcast_item.title : title}
            </h1>
            <div className={styles.bookInfo__author}>
              {book.authors !== undefined &&
                book.authors.map((author: IPodcastsDetailAuthor) => {
                  return (
                    <span key={author.alias}>
                      <span className={styles.bookInfo__categoryTxt}>{getAuthorFullName(author.first_name, author.middle_name, author.last_name)}</span>{' '}
                    </span>
                  );
                })}
            </div>

            {isPodcast && (
              <div className={styles.bookInfo__category}>
                <span className={styles.bookInfo__categoryName}>Подкаст: </span>
                <Link prefetch={false} href={`/podcasts/${book.podcast.alias}/`} className={styles.bookInfo__categoryLink}>
                  {book.podcast.title}
                </Link>
              </div>
            )}

            <div className={styles.bookInfo__category}>
              <span className={styles.bookInfo__categoryName}>Жанр:</span>
              {genres !== undefined &&
                !!genres.length &&
                genres.map((genre: IPodcastsDetailGenre) => {
                  const genreFullAlias = `/zhanr/${genre.alias}/`;
                  return (
                    <span key={genre.id}>
                      {' '}
                      <Link prefetch={false} href={genreFullAlias} className={styles.bookInfo__categoryLink}>
                        {genre.title}
                      </Link>
                    </span>
                  );
                })}
            </div>

            <div className={styles.bookInfo__category}>
              <span className={styles.bookInfo__categoryName}>Язык: </span>
              {isPodcast ? getLanguage(book.podcast.lang) : getLanguage(lang)}
            </div>

            {Number(book.adult) > 0 && (
              <div className={styles.bookInfo__category}>
                <span className={styles.bookInfo__categoryName}>Возрастное ограничение: </span>
                {book.adult}
              </div>
            )}

            {!isPodcast && (
              <div className={styles.bookInfo__category}>
                <span className={styles.bookInfo__categoryName}>Доступно: </span>
                {book.items.length} {getPodcastNoun(book.items.length)}
              </div>
            )}
            {isPodcast && (
              <div className={styles.bookInfo__category}>
                <span className={styles.bookInfo__categoryName}>Длительность: </span>
                {book.podcast_item.duration}
              </div>
            )}
            <div className={styles.bookInfo__category}>
              <span className={styles.bookInfo__categoryName}>Последнее обновление: </span>
              {isPodcast ? <time dateTime={book.podcast_item.created_at}>{format(parseISO(book.podcast_item.created_at), 'dd.MM.yyyy')}</time> : <time dateTime={book.created_at}>{format(parseISO(book.created_at), 'dd.MM.yyyy')}</time>}
            </div>
            <div className={styles.bookInfo__category}>
              <span className={styles.bookInfo__categoryName}>Добавлен: </span>
              {isPodcast ? <time dateTime={book.podcast_item.created_at}>{format(parseISO(book.podcast_item.created_at), 'dd.MM.yyyy')}</time> : <time dateTime={book.updated_at}>{format(parseISO(book.updated_at), 'dd.MM.yyyy')}</time>}
            </div>
            {isPodcast && isPodcastsFree && (
              <div className={styles.bookInfo__podcastPlayer}>
                {book.previous_podcast_item && (
                  <Link prefetch={false} title="Предыдущий выпуск подкаста" className={`${styles.bookInfo__playerBtn} ${styles.bookInfo__playerBtn_prev}`} href={`/podcasts/${book.podcast.alias}/${book.previous_podcast_item.alias}/`}></Link>
                )}
                <audio controls>
                  <source src={`${DEV_ABSOLUTE_URL}/api/v1/satellite/podcast/get-file?podcast_item_external_id=${book.podcast_item.external_id}`} type="audio/mpeg" />
                </audio>
                {book.next_podcast_item && <Link prefetch={false} title="Сдедующий выпуск подкаста" className={styles.bookInfo__playerBtn} href={`/podcasts/${book.podcast.alias}/${book.next_podcast_item.alias}/`}></Link>}
              </div>
            )}
            {isClient && !isPodcastsFree && (
              <div className={styles.bookInfo__btn}>
                <BookMidBtn txt="Купить и скачать" href={`https://www.litres.ru/pages/biblio_book/?art=${isPodcast ? book.podcast_item.external_id : book.external_id}`} target="_blank" rel="nofollow" />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BookInfoPodcast;
